import React, { createContext, useState } from "react";
import { PAGE_SIZE } from "@/constants/constants";

const OrdersContext = createContext({});

const OrdersProvider = ({ children }) => {
  const [orders, setOrders] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const pageSize = PAGE_SIZE;

  return (
    <OrdersContext.Provider
      value={{
        orders,
        setOrders,
        page,
        setPage,
        pageSize,
        searchText,
        setSearchText,
        totalPages,
        setTotalPages,
      }}
    >
      {children}
    </OrdersContext.Provider>
  );
};

export { OrdersContext, OrdersProvider };
